// NGRX
import { createSelector } from '@ngrx/store';

export const selectSiteState = (state: any) => state.site;

export const currentSite = createSelector(selectSiteState, site => site.data);
export const onboardingSite = createSelector(selectSiteState, site => site.data.onboarding);
export const currentSitePaymentMethodOneclick = createSelector(selectSiteState, site => site.data?.payment_methods?.oneclick || null);
export const currentSites = createSelector(selectSiteState, site => site.list || []);
